import React from "react";
import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardTeamHealth.css";

const getHealthStatus = (value, goodAt = 80) => {
    if (value >= goodAt) { return { color: "#16a34a", status: "Healthy" }; }
    if (value >= goodAt - 15) { return { color: "#2563eb", status: "Good" }; }

    return { color: "#ea580c", status: "Needs Attention" };
};

const DashboardTeamHealth = ({ summary = {} }) => {
    const employees = summary.employees ?? 0;
    const working = summary.working ?? 0;
    const openTasks = summary.open_tasks ?? 0;
    const overdueTasks = summary.overdue_tasks ?? 0;

    const utilization =
        employees > 0
            ? Math.round((working / employees) * 100)
            : 0;

    const overdueRatio =
        openTasks > 0
            ? Math.round((overdueTasks / openTasks) * 100)
            : 0;

    const metrics = [
        {
            title: "Employee Utilization",
            value: `${utilization}%`,
            ...getHealthStatus(utilization),
        },
        {
            title: "Overdue Ratio",
            value: `${overdueRatio}%`,
            color: overdueRatio <= 5 ? "#16a34a" : "#ea580c",
            status: overdueRatio <= 5 ? "Healthy" : "Needs Attention",
        },
        {
            title: "Working Employees",
            value: `${working}/${employees}`,
            color: "#2563eb",
            status: "Current",
        },
        {
            title: "Open Tasks",
            value: openTasks,
            color: "#7c3aed",
            status: openTasks > 0 ? "In Progress" : "All Clear",
        },
    ];

    return (
        <div className="team-health-card">
            <div className="team-health-header">
                <div>
                    <h2>Team Health</h2>
                    <p>Current operational health of your team.</p>
                </div>
            </div>

            <div className="team-health-list">
                {metrics.map((metric) => (
                    <div
                        key={metric.title}
                        className="team-health-item"
                    >
                        <div>
                            <div className="team-health-title">
                                {metric.title}
                            </div>

                            <div
                                className="team-health-status"
                                style={{ color: metric.color }}
                            >
                                {metric.status}
                            </div>
                        </div>

                        <div
                            className="team-health-value"
                            style={{ color: metric.color }}
                        >
                            {metric.value}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DashboardTeamHealth;
